import React from "react";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePickerCalendarIcon } from "../Icons/Icons";
import classes from "./filters.module.css";

/**
 * From/To date-range filter for the drawer. Date values stay owned by the
 * page (local state), matching the existing pattern.
 *
 * Props:
 *  - label: section title (e.g. "Joining Date")
 *  - fromLabel / toLabel: field captions (default "From" / "To")
 *  - from / to: dayjs values (or null)
 *  - onFromChange / onToChange: (value) => void
 */
const DateRangeFilter = ({
  label,
  fromLabel = "From",
  toLabel = "To",
  from,
  to,
  onFromChange,
  onToChange,
}) => {
  const fieldSx = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
  };

  return (
    <div className={classes.section}>
      {label && <span className={classes.sectionLabel}>{label}</span>}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className={classes.dateRow}>
          <div className={classes.dateField}>
            <span className={classes.dateLabel}>{fromLabel}</span>
            <DesktopDatePicker
              value={from}
              onChange={onFromChange}
              format="DD/MM/YYYY"
              slots={{ openPickerIcon: DatePickerCalendarIcon }}
              slotProps={{
                textField: { size: "small", fullWidth: true, sx: fieldSx },
              }}
            />
          </div>
          <div className={classes.dateField}>
            <span className={classes.dateLabel}>{toLabel}</span>
            <DesktopDatePicker
              value={to}
              onChange={onToChange}
              format="DD/MM/YYYY"
              minDate={from || undefined}
              slots={{ openPickerIcon: DatePickerCalendarIcon }}
              slotProps={{
                textField: { size: "small", fullWidth: true, sx: fieldSx },
              }}
            />
          </div>
        </div>
      </LocalizationProvider>
    </div>
  );
};

export default DateRangeFilter;
